import type { ComponentProps } from 'react';
import type { NodeTodo, Todo } from '../../../types';
import { ActivityTodoWidgetItem } from './activity-todo-widget-item';
import type { BaseTodoWidgetItem } from './base-todo-widget-item';
import { EventTodoWidgetItem } from './event-todo-widget-item';
import { PollTodoWidgetItem } from './poll-todo-widget-item';
import { PostTodoWidgetItem } from './post-todo-widget-item';
import { ProgramEventTodoWidgetItem } from './program-event-todo-widget-item';
import { UserTodoWidgetItem } from './user-todo-widget-item';
import { WithingsOrderPostTodoWidgetItem } from './withings-order-post-todo-widget-item';

export type TodosWidgetItemType = ComponentProps<typeof BaseTodoWidgetItem>['type'];

type P = {
  className?: string;
  todo: NodeTodo | Todo;
  type?: TodosWidgetItemType;
};

const TodosWidgetItem = ({ className, todo, type }: P) => {
  switch (todo.type) {
    case 'Activity':
      return <ActivityTodoWidgetItem className={className} todo={todo} type={type} />;
    case 'Event':
      return <ProgramEventTodoWidgetItem className={className} todo={todo} type={type} />;
    case 'event_enter':
    case 'event_rsvp':
      return <EventTodoWidgetItem className={className} todo={todo} />;
    case 'Poll':
      return <PollTodoWidgetItem className={className} todo={todo} type={type} />;
    case 'Post':
      return <PostTodoWidgetItem className={className} todo={todo} type={type} />;
    case 'User':
      return <UserTodoWidgetItem className={className} todo={todo} type={type} />;
    case 'WithingsOrderPost':
      return <WithingsOrderPostTodoWidgetItem className={className} todo={todo} type={type} />;
  }
};

export default TodosWidgetItem;
